import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { getProject } from '../services/webService';
import { translate } from '../utils/translations';
import { safeUrl } from '../utils/safeUrl';
import './Game.css';

function Game() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [projectSelected, setProjectSelected] = useState(null);
  const [url, setUrl] = useState('');

  useEffect(() => {
    const project = getProject(id);
    if (!project) {
      navigate('/home');
      return;
    }
    setProjectSelected(project);
    setUrl(`/assets/games/${project.id}/index.html`);
  }, [id, navigate]);

  if (!projectSelected) {
    return <div className="container-custom"><p>Loading...</p></div>;
  }

  return (
    <div className="container-custom">
      <br />
      <div className="row">
        <div className="col-lg-12">
          <ol className="breadcrumb">
            <li><Link to="/home">Home</Link></li>
            &nbsp;/&nbsp;
            <li className="active">
              <Link to={`/project/${projectSelected.id}`}>{translate(projectSelected.name)}</Link>
            </li>
          </ol>
        </div>
      </div>
      <iframe id="frame" title="game" src={safeUrl(url)} scrolling="no"></iframe>
    </div>
  );
}

export default Game;
